import StylableButton_ButtonComponent from '../components/StylableButton/viewer/skinComps/Button/Button.skin';
import StylableButton_ButtonController from '../components/StylableButton/viewer/StylableButton.controller';


const StylableButton_Button = {
  component: StylableButton_ButtonComponent,
  controller: StylableButton_ButtonController
};


export const components = {
  ['StylableButton_Button']: StylableButton_Button
};

